import { initialState } from "src/modals/embedded-integration-v2/constants/initialState"

export const initialSalesDynamicFieldState = {
    salesCardHeadline: { ...initialState },
    salesCardSubtitle: { ...initialState },
    salesCardFileUpload: { ...initialState },
    salesCardDescription: { ...initialState },
    salesCardBulletOptions: [{ ...initialState }],
}
